import * as React from "react";
import {CIRole} from "./Role";
import {LEADER_COLOR} from "../../../config/defaults";

function RoleIcon({fill=LEADER_COLOR}) {
  return <CIRole fill={fill} />;
}

export default RoleIcon;